export const POSTGRES_CODES = {
  UNIQUE_VIOLATION: "23505",
  FOREIGN_KEY_VIOLATION: "23503",
  NOT_NULL_VIOLATION: "23502",
  CHECK_VIOLATION: "23514",
  INSUFFICIENT_PRIVILEGE: "42501",
} as const;

export const POSTGREST_CODES = {
  NOT_FOUND: "PGRST116",
} as const;
